import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom"; 
import { selectIsNightMode, toggleMode } from "../../../redux/slices/modeSlice";
import { IoMoonSharp } from "react-icons/io5";
import { IoIosSunny } from "react-icons/io";
import { IoMdNotificationsOutline } from "react-icons/io";
import { MdAccountBalanceWallet, MdRefresh, MdAdd } from "react-icons/md";
import { NotificationApiService } from "../../../service/notificationApiService";
import { WalletApiService } from "../../../service/seller/walletApiService";
import { PiUserCircle } from "react-icons/pi";
import Profile from "../profile";
import { getAuthLocalStorage } from "../../../storage/localStorage";
import { ToastTypes, useMessage } from "../../../base/context/MessageProvider";
import { AuthApiService } from "../../../service/authApiService";
import { addItems, sidebarData } from "../../../redux/slices/sidebarSlice";
import { menuIcon } from "../../../website/assets/icons";
import Logo from "../../../assets/images/common/logo.png";
import "./style.css";

export default function Tabs({setMenuDisplay,menuDisplay}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isNightMode = useSelector(selectIsNightMode);
  const [userProfile, setUserProfile] = useState(false);
  const [data, setData] = useState({});
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifItems, setNotifItems] = useState([]);
  const [unseenCount, setUnseenCount] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);
  const message = useMessage();
  const tabs = useSelector(sidebarData);

  const location = useLocation(); 

  const goAuth = (path) => {
    const url = window.location.pathname + window.location.search + window.location.hash;
    sessionStorage.setItem("postAuthRedirect", url);
    navigate(path, {
      state: { from: { pathname: location.pathname, search: location.search, hash: location.hash } }
    });
  };

  useEffect(() => {
    if (getAuthLocalStorage().isLoggedIn && getAuthLocalStorage().loginHeader) {
      handleUserProfileApi();
      refreshNotifications();
      // Only fetch wallet balance for seller users
      if (isSeller()) {
        fetchWalletBalance();
      }
    }
  }, [getAuthLocalStorage().isLoggedIn]);

  const refreshNotifications = () => {
    NotificationApiService.getUnseenCount()
      .then(res => {
        if (res?.status?.code === 200) setUnseenCount(res?.data?.count || 0);
      })
      .catch(() => {});
  };

  const openNotifications = () => {
    if (!(getAuthLocalStorage().isLoggedIn && getAuthLocalStorage().loginHeader)) {
      // navigate("/login");
      goAuth("/login");
      return;
    }
    setNotifOpen(!notifOpen);
    if (!notifOpen) {
      NotificationApiService.getNotifications("?page=1&limit=10")
        .then(res => {
          if (res?.status?.code === 200) {
            setNotifItems(res?.data?.notifications || []);
            NotificationApiService.markAllSeen().finally(() => refreshNotifications());
          }
        })
        .catch(() => {});
    }
  };

  /**
   * @summary This function checks if the user is logged in and updates the state of setUserProfile accordingly.
   * @author Diksha Lalit
   * @param {function} setUserProfile - A function to update the state of setUserProfile.
   * @returns {void}
   */

  const handleUserProfile = () => {
    if (getAuthLocalStorage().loginHeader && getAuthLocalStorage().isLoggedIn) {
      setUserProfile(true);
    } else {
      // navigate("/login");
      goAuth("/login"); 
    }
  };

  /**
   * @summary Handles toggling between day and night mode.
   * @author Diksha Lalit
   * @param {function} dispatch - Redux dispatch function.
   * @param {function} toggleMode - Action creator function to toggle the mode state.
   * @returns {void}
   */
  const handleMode = () => {
    dispatch(toggleMode());
  };

  //user profile api integration
  const handleUserProfileApi = () => {
    AuthApiService.getProfile()
      .then((res) => {
        if (res.status.code === 200) {
          setData(res.data);
        } else if (res.status.code === 402) {
          // DON'T SHOW TOAST FOR LOGIN ERROR, DIRECTLY REDIRECT TO LOGIN PAGE
          // message.showToast(res.error.message, ToastTypes.ERROR);
          // navigate("/login", { replace: true });
          goAuth("/login"); 
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
      });
  };

  //remove the tab from opened tabs
  const updateTabs = async (e, item) => {
    e.preventDefault();
    const activeTabs = tabs.filter((tab) => tab.opened);
    const index = activeTabs.findIndex((x) => x.head === item.head);

    const updatedTabs = await tabs.map((tab) => {
      if (item.tabLink === tab.tabLink) {
        return { ...tab, active: false, opened: false };
      } else {
        return { ...tab };
      }
    });

    if (activeTabs.length > 1) {
      await dispatch(addItems(updatedTabs));
    }
    if (activeTabs.length !== index + 1) {
      navigate(activeTabs[index + 1].link);
    } else if (activeTabs.length === index + 1 && activeTabs.length > 1) {
      navigate(activeTabs[index - 1].link);
    }
  };

  const handlePage = (link) => {
    navigate(link);
  };

  const handleMobileMenu=()=>{
    setMenuDisplay(!menuDisplay)
  }

  const fetchWalletBalance = () => {
    setWalletLoading(true);
    WalletApiService.getWalet()
      .then(res => {
        console.log('Wallet API Response:', res); // Debug log
        if (res.status.code === 200) {
          // Handle different response structures
          let balance = 0;
          if (res.data?.balance !== undefined) {
            balance = res.data.balance;
          } else if (res.data?.wallet?.balance !== undefined) {
            balance = res.data.wallet.balance;
          } else if (typeof res.data === 'number') {
            balance = res.data;
          }
          setWalletBalance(Number(balance) || 0);
        } else {
          message.showToast('Failed to fetch IM Cash balance', ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        console.error('Wallet API Error:', err);
        message.showToast('Failed to fetch IM Cash balance', ToastTypes.ERROR);
      })
      .finally(() => {
        setWalletLoading(false);
      });
  };

  const handleRecharge = () => {
    navigate('/seller/wallet');
  };

  const handleRefreshBalance = () => {
    fetchWalletBalance();
  };

  const isSeller = () => {
    // Check if current path is seller panel or user role is seller
    return window.location.pathname.includes('/seller') || 
           data?.role === 'seller' || 
           !window.location.pathname.includes('/admin');
  };

  return (
    <div className="tabs_bg">
      <div
        className={`tabs_row ${
          isNightMode ? "tabs_row_dark" : "tabs_row_light"
        }`}
      >
        {tabs?.length &&
          tabs
            ?.filter((tab) => tab?.opened)
            ?.map((tab, index) => {
              return (
                <div
                  key={index}
                  className={`tab_item ${
                    isNightMode ? "tab_item_dark" : "tab_item_light"
                  } ${
                    tab?.active
                      ? `${
                          isNightMode
                            ? "active_tab_item_dark"
                            : "active_tab_item_light"
                        }`
                      : ""
                  }`}
                  onClick={() => handlePage(tab.tabLink)}
                >
                  <div className="text-nowrap tab_head">{tab?.name}</div>

                  {tab?.active ? (
                    <IoClose
                      className="cursor-pointer tab_remove_icon"
                      onClick={(e) => updateTabs(e, tab)}
                    />
                  ) : null}
                </div>
              );
            })}
      </div>

      <div className="tabs_small_menu" onClick={()=>handleMobileMenu()}>
        <div className="navbar_icon">{menuIcon}</div>
        <img src={Logo} className="app_logo" onClick={()=>navigate('/')}/>
      </div>

      

      

      <div
        className={`navbar_icons ${
          isNightMode ? "navbar_icons_dark" : "navbar_icons_light"
        }`}
      >
        {/* Wallet Balance Section - Only for Seller */}
        {isSeller() && (
          <div className="wallet_balance_section">
            <div className="wallet_balance_container">
              <MdAccountBalanceWallet className="wallet_icon" />
              <span className="wallet_balance_text">
                ₹{walletLoading ? '...' : Number(walletBalance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
              <div className="wallet_actions">
                <MdRefresh 
                  className={`wallet_action_icon ${walletLoading ? 'rotating' : ''}`}
                  onClick={handleRefreshBalance}
                  title="Refresh Balance"
                />
                <MdAdd 
                  className="wallet_action_icon"
                  onClick={handleRecharge}
                  title="Recharge Wallet"
                />
              </div>
            </div>
          </div>
        )}

        <div style={{ position: "relative" }}>
          <IoMdNotificationsOutline className="navbar_icon" onClick={openNotifications} />
          {unseenCount > 0 && (
            <span style={{ position: "absolute", top: -4, right: -4, background: "#ef4444", color: "#fff", borderRadius: 9999, padding: "0 6px", fontSize: 12 }}>
              {unseenCount}
            </span>
          )}
          {notifOpen && (
            <div style={{ position: "absolute", right: 0, top: 28, width: 300, background: "#fff", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", borderRadius: 8, zIndex: 1000 }}>
              <div style={{ padding: 12, borderBottom: "1px solid #eee", fontWeight: 600 }}>Notifications</div>
              <div style={{ maxHeight: 320, overflowY: "auto" }}>
                {notifItems.length === 0 ? (
                  <div style={{ padding: 12, color: "#6b7280" }}>No notifications</div>
                ) : (
                  notifItems.map((n, idx) => (
                    <div key={idx} style={{ padding: 12, borderBottom: "1px solid #f3f4f6", cursor: n?.link ? "pointer" : "default" }} onClick={() => { if (n?.link) navigate(n.link); setNotifOpen(false); }}>
                      <div style={{ fontSize: 14, color: "#111827" }}>{n?.message}</div>
                      <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>{new Date(n?.createdAt).toLocaleString()}</div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
        <PiUserCircle
          className="navbar_icon"
          onClick={() => handleUserProfile()}
        />
      </div>

      <div className="seller_panel_profile_wrapper">
        {userProfile ? (
          <Profile
            data={data}
            onClickOutside={() => {
              setUserProfile(false);
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
